export default {
    hdc: null,
    canvas: null,
    drawPoly(coOrdStr)
    {
        const mCoords = coOrdStr.split(',');
        let i;
        const n = mCoords.length;
    
        this.hdc.beginPath();
        this.hdc.moveTo(mCoords[0], mCoords[1]);
        for (i=2; i<n; i+=2)
        {
            this.hdc.lineTo(mCoords[i], mCoords[i+1]);
        }
        this.hdc.lineTo(mCoords[0], mCoords[1]);
        this.hdc.stroke();
        this.hdc.fill();
    },
    drawRect(coOrdStr) {
        const mCoords = coOrdStr.split(',');
        const left = mCoords[0];
        const top = mCoords[1];
        const right = mCoords[2];
        const bot = mCoords[3];
        this.hdc.strokeRect(left,top,right-left,bot-top); 
        this.hdc.fillRect(left,top,right-left,bot-top);
    },
    myHover(element) {
        const hoveredElement = element;
        const coordStr = element.getAttribute('coords');
        const areaType = element.getAttribute('shape');

        switch (areaType)
        {
            case 'polygon':
            case 'poly':
                this.drawPoly(coordStr);
                break;

            case 'rect':
                this.drawRect(coordStr);
        }
        return element.dataset;
    },
    myLeave() {
        this.hdc.clearRect(0, 0, this.canvas.width, this.canvas.height);
    },
    setCanvasProps(props = {}) {
      if(this.hdc){
        console.warn('canvas not created yet!')
        return;
      }
      if(props.lineWidth)
        this.hdc.lineWidth = props.lineWidth;
      if(props.strockeStyle)
        this.hdc.strockeStyle = props.strockeStyle;
      if(props.fillStyle)
        this.hdc.fillStyle = props.fillStyle;
    },
    myInit(img, can){
        this.canvas = can;
        // get it's position and width+height
        const x = img.offsetLeft;
        const y = img.offsetTop;
        const w = img.clientWidth;
        const h = img.clientHeight;

        // move the canvas, so it's contained by the same parent as the image
        // const imgParent = img.parentNode;
        // imgParent.appendChild(can);

        // place the canvas in front of the image
        can.style.zIndex = 1;

        // position it over the image
        can.style.left = x+'px';
        can.style.top = y+'px';

        // make same size as the image
        can.setAttribute('width', w+'px');
        can.setAttribute('height', h+'px');

        // get it's context
        this.hdc = can.getContext('2d');

        // set the 'default' values for the colour/width of fill/stroke operations
        this.hdc.fillStyle = '#7367f0';
        this.hdc.strokeStyle = '#7367f0';
        this.hdc.lineWidth = 1;
    }
}